// extracted by mini-css-extract-plugin
export var discard = "_2w-3";
export var muiTooltipTooltip = "_2w-5";
export var notificationBar = "_2w-2";
export var saveButtonHoverSlotWrapper = "_2w-4";
export var show = "_2w-1";
export var spacer = "_2w-0";